import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import router from 'next/router';

const Header = () => {
  const onGoBackClick = () => {
    router.back();
  };

  return (
    <header className="tw-w-100 tw-z-10	 tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-text-[1rem] tw-font-bold tw-leading-5 tw-shadow-md">
      <ArrowBackIcon onClick={onGoBackClick} />
      My Account
    </header>
  );
};

export default Header;
